import type { WindowUnit } from "building-types/windows/windowTypes";
import type { Table } from "common/data/table";

export function windowUnitsOnLevel(levelId: string | undefined, units: Table<WindowUnit>): WindowUnit[] {
  const a: WindowUnit[] = [];
  for (const id in units) {
    const unit = units[id];
    if (unit.windowPlacement.frontRoom?.level.id === levelId) {
      a.push(unit);
    }
  }
  return a;
}
